import { ETheme } from '@enums/theme.enum';

export const themeStorageKey = 'fixxer-connect-theme';
export const themeClass = 'dark';
export const defaultTheme = ETheme.System;
